'use strict';

import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 

class VideoScroll {

	constructor($target) {

        //Store panel references
        let $heroPanel = $target.find('.block_video-scroll__hero_panel')
        let $videoPanels = $target.find('.block_video-scroll__video_item')
        var videoMediumScreen = window.matchMedia("(min-width:768px)");

        //Store videos and their containers
        let $videoContainers = $target.find('.block_video-scroll__video_container')
        let $allVideos = $target.find('video')

        //Logo container for animating the color
        let $header__logo_desk_svg = $('.header__logo-desk').find('.cls-1')

        //Menu for changing the colour
        let $menuBars = $('#hamburger').find('.hamburgerSpan')
        //Get scroll duration properties
        let panelScrollConfig = {
            splash:{
                endScreenPercentage:50
            },
            video:{
                endScreenPercentage:110
            }
        }

        let totalScrollDuration = panelScrollConfig.splash.endScreenPercentage + (panelScrollConfig.video.endScreenPercentage*$videoPanels.length)+"%"

        //Define the scroll timeline
        let scroll_TL
        let scroll_Trigger
        function init(){
            initTimeline();
            initVideoEventListeners();
        }

        function initVideoEventListeners(){
            $videoContainers.find('video').each(function(){
                $(this)[0].addEventListener('ended',(e) => {onVideoEnd($(this)[0],e)},false);
            })
        }

        function onVideoEnd(target,event){

            target.currentTime = 0;
            target.play();
        }


        function initTimeline(){

         
            scroll_TL = gsap.timeline({scrollTrigger:{
                trigger: $target[0],
                pin:true,
                start: "top top",
                end: totalScrollDuration,
                invalidateOnRefresh:true,
                scrub:1
            }});
            
            scroll_Trigger = scroll_TL.scrollTrigger
            scroll_TL.to($heroPanel[0], {duration:0.5, opacity:0})
            scroll_TL.call(onHeroPanelLeave, [],"-=0.49");

            //Animate top-most first by reversing the list 
            $($videoPanels.get().reverse()).each(function(index){

                let panel_text = $(this).find('.block_video-scroll__video_overlay_text')
                let panel_video = $(this).find('.block_video-scroll__video_container')
                let panel_videoElement = $(this).find('video');

                // gsap.set(".full_size_panel", {perspective:400})
                gsap.set(panel_video, {y:"10%"})

                scroll_TL.call(onStartOfPanel, [ $(this).data('index')]);
                scroll_TL.fromTo(panel_text[0], {opacity:0},{delay:0, duration:1, opacity:1})
                scroll_TL.to(panel_text[0], {delay:0, duration:0.5, opacity:0})
                // scroll_TL.fromTo(panel_video[0], {scale:2.5, paddingTop:"55vh"}, {delay:-0.8, duration:1.2, scale:1, paddingTop:"56%", ease: "back.out(1)"})
                scroll_TL.fromTo(panel_video[0], {scale:2.5, paddingTop:"55vh"}, {delay:-0.5, duration:1.2, scale:1, paddingTop:"56%",})
                scroll_TL.to(panel_video[0], {delay:-0.5, duration:0.5, y:"0%"})
                // scroll_TL.fromTo(panel_video[0], {scale:2.5}, {delay:-0.5, duration:1.2, scale:1})
                scroll_TL.call(onStartOfPanelContent, [ $(this).data('index')], "-=0.7");
                scroll_TL.to(panel_videoElement,{width:"100%", delay:-1.2,duration:1.2});
   
                if(index == 0){
                    if(videoMediumScreen.matches){
                        scroll_TL.to($header__logo_desk_svg, {delay:-1.5, duration:0.2, scale:1, fill:"#221f1f", stagger:0.05})
                        scroll_TL.call(changeHamburgerMenu,[], "-=0.9");
                    }
                }
                ///adding delay on video element to interact with it
                scroll_TL.to(panel_videoElement,{width:"100%", duration:3});


                if(index<$videoPanels.length-1){
                    scroll_TL.call(onLeavingPanelContent, [ $(this).data('index')]);
                    scroll_TL.to($(this)[0], {duration:0.5, opacity:0})
                    scroll_TL.call(onEndOfPanel, [ $(this).data('index')]);
                }
            })
        }

        function onHeroPanelLeave(){
            console.log("SCROLL DIRECTION HERO LEAVE")
            if(scroll_Trigger.direction > 0){
                console.log("HERO LEAVE", $allVideos[0])
                $allVideos[$allVideos.length-1].play()
            }else{
                console.log("HERO LEAVE", $allVideos[0])
                $allVideos[$allVideos.length-1].pause()
            }
        }

        function changeHamburgerMenu(){
            if(scroll_Trigger.direction > 0){
                $menuBars.addClass("hamburgerSpan--dark");
            }else{
                $menuBars.removeClass("hamburgerSpan--dark");
            }

        }

        function onStartOfPanelContent(forIndex){
            console.log("onStartOfPanelContent")
            //Once the video is almost positioned into its focal point, we should enable the controlls

            let panelTarget = $videoPanels[forIndex]
            let videoElement = $(panelTarget).find('video')[0]
            
            if(scroll_Trigger.direction > 0){
                videoElement.controls = true
            }else{
                videoElement.controls = false
            }

        }

        function onStartOfPanel(forIndex){
            console.log("onStartOfPanel")
            let panelTarget = $videoPanels[forIndex]
            let videoElement = $(panelTarget).find('video')[0]

            if(scroll_Trigger.direction > 0){
                //We are scrolling into to the content
                updatePanelPointerEvents(panelTarget)
                videoElement.play()
            }else{
                videoElement.pause()
            }

    
        }

        function onEndOfPanel(forIndex){
            console.log("onEndOfPanel")
            let panelTarget = $videoPanels[forIndex]
            let videoElement = $(panelTarget).find('video')[0]

            let nextPanel = $videoPanels[forIndex-1]
            let nextPanelVideoElement = $(nextPanel).find('video')[0]

            if(scroll_Trigger.direction < 0){
                //We are scrolling back up to the content
                updatePanelPointerEvents(panelTarget)
                videoElement.play()
            }else{
                videoElement.pause()
            }
        }

        function onLeavingPanelContent(forIndex){
            console.log("onLeavingPanelContent")
            let currrentPanel = $videoPanels[forIndex]
            let currentPanelVideoElement = $(currrentPanel).find('video')[0]
            let nextPanel = $videoPanels[forIndex-1]
            let nextPanelVideoElement = $(nextPanel).find('video')[0]
            let panelAfterNext = $videoPanels[forIndex-2]
            let afternNxtPanelVideoElement = $(panelAfterNext).find('video')[0]

            if(scroll_Trigger.direction > 0){
                currentPanelVideoElement.pause()
            }else{
                currentPanelVideoElement.play()
            }

            if(nextPanelVideoElement){
                if(scroll_Trigger.direction > 0){
                    //We are scrolling down the content
                    nextPanelVideoElement.play();
                }
            }
            if(afternNxtPanelVideoElement){
                if(scroll_Trigger.direction > 0){
                    //We are scrolling down the content
                    //nextPanelVideoElement.play();
                }
            }

        }

        function updatePanelPointerEvents(panelTarget){
            //lets remove pointer events on all panels
            $(".block_video-scroll__full_size_panel").removeClass("block_video-scroll__full_size_panel--active");
            //lets enable pointer events for the active panel
            $(panelTarget).addClass("block_video-scroll__full_size_panel--active")
        }



        init();

		return {

			//Public properties
			name:name,

			publicVideoScroll:function(string){



			}

		}

	}

}

export default VideoScroll;